import { IndexRouteContent, RouteNode } from 'router/declarative/routeNode';
import { featureFlagBoundary } from 'router/declarative/featureFlagBoundary';
import { Features } from '@ardoq/features';
import { AppModules } from '../appContainer/types';

export const routes = {
  path: '/discover',
  appModule: AppModules.DISCOVER_LANDING_PAGE,
  content: featureFlagBoundary(
    [Features.DISCOVER_CORE_LANDING_PAGE_AND_NAVIGATION],
    { pageName: 'Discover' }
  ),
  children: [
    {
      path: { index: true },
      content: async (): IndexRouteContent =>
        (await import('./DiscoverLandingPage')).DiscoverLandingPage,
    },
  ],
} as const satisfies RouteNode;
